__turbopack_context__.v({
  "arrowButton": "ArrowButtons-module__yuEjHa__arrowButton",
  "arrowButtons": "ArrowButtons-module__yuEjHa__arrowButtons",
});
